export default __webpack_public_path__ + "static/media/slice.cdbf94d6.svg";